/* eslint-disable no-console */

if (process.env.NODE_ENV === 'production') {
  navigator.serviceWorker?.getRegistrations()
    .then(registrations => {
      registrations.forEach(registration => registration.unregister())
    })
    .catch(error => {
      console.error('Error during service worker cleanup:', error)
    })
}
